// --- API Hooks ---
import {
  useGetCheckoutDataQuery,
  useUpdatePaymentMethodMutation,
  useProcessCheckoutMutation,
} from "../templates/ecommerce/checkout/api/checkoutApi";

// --- Custom Logic Hooks ---
import { useCheckoutSubmit } from "../templates/ecommerce/checkout/hooks/useCheckoutSubmit";
import { useLegalAgreements } from "../templates/ecommerce/checkout/hooks/useLegalAgreements";
import { usePaymentError } from "../templates/ecommerce/checkout/hooks/usePaymentError";
import { useUpdatePaymentMethod } from "../templates/ecommerce/checkout/hooks/useUpdatePaymentMethod";

// --- Validation Schemas ---
import {
  createBillingSchema,
  createShippingSchema,
} from "../templates/ecommerce/checkout/helpers/checkoutValidation";

// --- Redux Actions (Managing checkout flow state) ---
import {
  setCurrentStep,
  setSelectedPaymentMethod,
  setUseBillingForShipping,
  setCustomerNote,
  setIsMailingSubscribed,
} from "../templates/ecommerce/checkout/checkoutSlice";

// --- Redux Selectors ---
import {
  selectCurrentStep,
  selectSelectedPaymentMethod,
  selectCustomerNote,
  selectCheckoutApiData,
} from "../templates/ecommerce/checkout/checkoutSelectors";

// --- UI Components ---
import CheckoutPage from "../templates/ecommerce/checkout/components/CheckoutPage";
import CheckoutOrderSummary from "../templates/ecommerce/checkout/components/CheckoutOrderSummary";
import CheckoutProgress from "../templates/ecommerce/checkout/components/CheckoutProgress";

export const checkout = {
  // 1. API Hooks
  api: {
    useGetCheckoutDataQuery,
    useUpdatePaymentMethodMutation,
    useProcessCheckoutMutation,
  },

  // 2. Business Logic Hooks
  hooks: {
    useCheckoutSubmit,
    useLegalAgreements,
    usePaymentError,
    useUpdatePaymentMethod,
  },

  // 3. UI Components
  components: {
    CheckoutPage,
    CheckoutOrderSummary,
    CheckoutProgress,
  },

  // 4. Redux Actions
  actions: {
    setCurrentStep,
    setSelectedPaymentMethod,
    setUseBillingForShipping,
    setCustomerNote,
    setIsMailingSubscribed,
  },

  // 5. Redux Selectors
  selectors: {
    selectCurrentStep,
    selectSelectedPaymentMethod,
    selectCustomerNote,
    selectCheckoutApiData,
  },

  // 6. Validation
  validation: {
    createBillingSchema,
    createShippingSchema,
  },
};
